import { render } from "./Pie8Charts.vue?vue&type=template&id=0e463e61&scoped=true"
import script from "./Pie8Charts.vue?vue&type=script&lang=js"
export * from "./Pie8Charts.vue?vue&type=script&lang=js"

import "./Pie8Charts.vue?vue&type=style&index=0&id=0e463e61&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e463e61"]])

export default __exports__